import lax from "lax.js";

export function parallax() {
	const elements = document.querySelectorAll("[data-lax-translate-y]");
	if (!elements.length) return;

	lax.init();
	lax.addDriver("scrollY", () => window.scrollY);
	const rootStyle = getComputedStyle(document.documentElement);
	const parallaxOffsetValue = rootStyle.getPropertyValue("--parallax-offset").trim();

	function initPanelsParallax() {
		if (window.innerWidth < 768) {
			lax.elements = [];
			return;
		}
		let offset;
		if (parallaxOffsetValue.endsWith("vh")) {
			const vh = parseFloat(parallaxOffsetValue);
			offset = (window.innerHeight * vh) / 100;
		} else {
			offset = parseFloat(parallaxOffsetValue);
		}
		elements.forEach((element) => {
			const panelsParent = element.closest(".panels");
			if (!panelsParent) return;
			const rect = panelsParent.getBoundingClientRect();
			const panelsHeight = panelsParent.offsetHeight;
			const viewportHeight = window.innerHeight;

			const topAbs = window.scrollY + rect.top;
			const bottomAbs = topAbs + panelsHeight;

			let start, end;

			if (panelsHeight >= viewportHeight) {
				start = topAbs;
				end = bottomAbs - viewportHeight;
			} else {
				start = topAbs - viewportHeight;
				end = bottomAbs;
			}

			if (end <= start) end = start + 1;

			lax.addElement(element, {
				scrollY: {
					translateY: [
						[start, end],
						[offset, -offset],
					],
				},
			});
		});
	}

	initPanelsParallax();

	let resizeRaf;
	const reinit = () => {
		cancelAnimationFrame(resizeRaf);
		resizeRaf = requestAnimationFrame(initPanelsParallax);
	};

	window.addEventListener("resize", reinit);
	window.addEventListener("load", reinit);
}
